import { Component, OnInit, Input } from '@angular/core';
import { RequestProgressData } from '@app/models';

@Component({
    selector: 'app-request-progress',
    templateUrl: './request-progress.component.html',
    styleUrls: ['./request-progress.component.scss'],
    standalone: false
})
export class RequestProgressComponent implements OnInit {

  @Input('data') data: RequestProgressData | null = null;
  constructor() { }

  ngOnInit(): void {
    // no initial operations required
  }

}
